(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.factory('AdditionalInfoField', [AdditionalInfoFieldFn]);

    /* additional info field object */
    function AdditionalInfoFieldFn() {
        var AdditionalInfoField = function () {

            // define default values
            this.caption = null;
            this.isRequired = false;
            this.fk_User = 0;

            // vm id
            this.vmId = null;

            // export
            this.extend = extend;

            // extend
            function extend(object) {
                var self = this;
                angular.extend(self, object);
                // id
                self.vmId = Math.random();
            }

        };

        return AdditionalInfoField;

        

    }
})();